import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=346355b7&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346355b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('346355b7')) {
      api.createRecord('346355b7', component.options)
    } else {
      api.reload('346355b7', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=346355b7&scoped=true&", function () {
      api.rerender('346355b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ydrpk9orsoMV/JS/comp/Voucher-Unit.vue"
export default component.exports